import type * as React from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { selectUserPersonalInformation } from "store/reducers/user/UserAccountSlice";
import ActivePlanCard from "./ActivePlanCard";
import InactivePlanCard from "./InactivePlanCard";
import { planCardSx } from "./planInformationStyles";

type PlanSummaryCardProps = {
  onReactivateClick: () => void;
};

const PlanSummaryCard: React.FC<PlanSummaryCardProps> = ({
  onReactivateClick
}) => {
  const userInformation = useSelector(selectUserPersonalInformation);
  const isMemberActive = userInformation.isMemberActive !== false;

  return (
    <Box sx={planCardSx}>
      {isMemberActive ? (
        <ActivePlanCard />
      ) : (
        <InactivePlanCard onReactivateClick={onReactivateClick} />
      )}
    </Box>
  );
};

export default PlanSummaryCard;
